import { PasskeySettings as Settings } from '@valiant/ui-shared'
import { environment } from '../environment'

export function PasskeySettings({ token, targetUserId }: { token: string; targetUserId?: string }) {
  return <Settings apiUrl={environment.API_URL} token={token} targetUserId={targetUserId} />
}
